export default __webpack_public_path__ + "static/media/time.dee42b07.svg";